function Footer() {
  return (
    <div className="w-full flex flex-col gap-4 bg-[#FAFAFA] tracking-wider px-4 py-2 md:py-4">
      <div className="w-full flex flex-col md:flex-row items-center gap-6 justify-between">
        <div className="flex flex-row items-center gap-2 text-gray-600">
          <img src="./logo_white.webp" alt="logo" className="w-16 h-16"></img>
          <div className="leading-7">
            拓圖科技股份有限公司
            <br />
            TWO-TOOL TECH CO., LTD.
          </div>
        </div>
        <div className="flex flex-col items-center md:items-end gap-0.5 text-gray-600">
          <div>03-5320890</div>
          <div>service@two-tool.com.tw</div>
          <div>新竹市東區鐵道路一段28巷37號5樓</div>
        </div>
      </div>
      <div className="w-full text-sm text-gray-500 text-center pt-6 md:pt-0">
        Copyright © 2022-2025 拓圖科技 Two-Tool Tech. All Rights Reserved{" "}
      </div>
    </div>
  );
}

export default Footer;
